import React from 'react';
import { Dialog } from 'primereact/dialog';
import i18n from '../../i18n';
import './ModalMensagem.css';

const ModalMensagem = ({ visible, onHide, tipo = 'aviso', mensagem, imagem }) => {
    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            closable
            className={`modal-mensagem modal-${tipo}`}
            header={null}
            footer={null}
            modal
        >
            <div className="modal-conteudo">
                {imagem && <img src={imagem} alt={i18n.t('COMMON.LABEL.ILLUSTRATION')} className="modal-imagem" />}
                <p className="modal-texto">{mensagem}</p>
            </div>
        </Dialog>
    );
};

export default ModalMensagem;
